<template>
    <div id="user-inventory-form">
        <div class="tw-mt-4" v-for="(inventory, index) in inventoryItems">
            <div class="tw-flex tw-gap-2">
                <div class="tw-w-1/3">
                    <bordered-input :disabled="!! inventory.revoked_at">
                        <template #label>
                            <label :for="'name-' + index">
                                Bezeichnung
                            </label>
                        </template>
                        <template #input>
                            <input
                                name="name"
                               type="text"
                               v-model="inventory.name"
                               placeholder="Bezeichnung"
                            >
                        </template>
                    </bordered-input>

                    <div v-if="FormUtils.hasError(errors, `inventory.${index}.name`)" class="tw-text-danger-primary">
                        {{ FormUtils.getErrorMessage(errors, `inventory.${index}.name`)}}
                    </div>
                </div>

                <div class="tw-flex-1">
                    <bordered-input :disabled="!! inventory.revoked_at" type="textarea">
                        <template #label>
                            <label :for="'description-' + index">
                                weitere Informationen
                            </label>
                        </template>
                        <template #input>
                            <textarea
                                name="description"
                                type="text"
                                v-model="inventory.description"
                                placeholder="weitere Informationen"
                                rows="3"
                            ></textarea>
                        </template>
                    </bordered-input>

                    <div v-if="FormUtils.hasError(errors, `inventory.${index}.description`)" class="tw-text-danger-primary">
                        {{ FormUtils.getErrorMessage(errors, `inventory.${index}.description`)}}
                    </div>
                </div>

                <div>
                    <div class="tw-flex tw-gap-2">
                        <button v-if="! inventory.revoked_at" class="cu-btn-default" type="button" @click="revokeAccess(inventory)" title="Zurückgegeben">
                            <i class="fa fa-angle-double-right"></i>
                        </button>

                        <button v-if="!! inventory.revoked_at" class="cu-btn-default" type="button" @click="restoreAccess(inventory)" title="Wiederherstellen">
                            <i class="fa fa-undo"></i>
                        </button>

<!--                        <button class="cu-btn-danger" type="button" @click="deleteRow(index)" title="Zeile Löschen">-->
<!--                            <i class="fa fa-trash"></i>-->
<!--                        </button>-->
                    </div>
                </div>
            </div>
        </div>

        <div class="tw-mt-4">
            <button class="cu-btn-default" type="button" @click="addRow">
                <i class="fa fa-plus"></i>
                Zeile hinzufügen
            </button>
        </div>

        <div class="tw-mt-8 tw-flex">
            <button type="button" class="cu-btn" @click="save">
                <i class="fa fa-save"></i> Speichern
            </button>

            <button type="button" class="cu-btn-default tw-ml-1" @click="abort">
                <i class="fa fa-times"></i> Abbrechen
            </button>
        </div>
    </div>
</template>

<script>
import BorderedInput from "../Redesign/BorderedInput";
import moment from "moment";
import axios from "axios";
import FormUtils from "../../Support/FormUtils";

export default {
    components: {
        BorderedInput,
    },

    props: {
        user: {
            required: true,
            type: Object,
        },

        inventory: {
            type: Array,
            required: true,
        },

        saveEndpoint: {
            type: String,
            required: true,
        },

        abortUrl: {
            type: String,
            required: true,
        },

        changedUrl: {
            type: String,
            required: true,
        }
    },

    data() {
        return {
            FormUtils: FormUtils,
            inventoryItems: [...this.inventory],
            errors: null,
        }
    },

    methods: {
        addRow() {
            this.inventoryItems.push(this.emptyItem());
        },

        emptyItem() {
            return {
                id: null,
                name: null,
                description: null,
                revoked_at: null,
            };
        },

        // deleteRow(index) {
        //     this.inventoryItems.splice(index, 1);
        // },

        revokeAccess(inventory) {
            inventory.revoked_at = moment().format('YYYY-MM-DD HH:mm:ss');
        },

        restoreAccess(inventory) {
            inventory.revoked_at = null;
        },

        abort() {
            window.location.href = this.abortUrl;
        },

        save() {
            this.errors = null;

            axios
                .patch(this.saveEndpoint, {
                    inventory: this.inventoryItems
                })
                .then(response => {
                    window.location.href = this.changedUrl;
                })
                .catch(error => {
                    // handle errors
                    this.errors = error?.response?.data?.errors;
                });
        }
    },

    mounted() {
        if (this.inventoryItems.length === 0) {
            this.addRow();
        }
    }
}
</script>
